import { AutocompleteInput as RaAutocompleteInput } from 'react-admin';
import { styled } from '@mui/material';

const AutocompleteInput = styled(RaAutocompleteInput)({
  minWidth: '14.5rem',
});

export default AutocompleteInput;
